import { Injectable } from '@angular/core';
import * as moment from 'moment';

export enum moment_duration {
    seconds = 'seconds',
    minutes = 'minutes',
    hours = 'hours',
    days = 'days',
    weeks = 'weeks',
    months = 'months',
    years = 'years'
}

export enum date_format {
    medium = 'MMM DD, y, h:mm:ss a'
}

@Injectable({
    providedIn: 'root'
})
export class DateUtilService {
    getDateForSlot(dateString: string): Date {
        return moment(dateString)
            .second(0)
            .millisecond(0)
            .toDate();
    }

    getSlotTime(dateString: string): string {
        if (dateString == null)
            return null;
        let a = new Date(dateString).toDateString();
        let b = new Date(dateString).toLocaleString().split(",")[1];
        return a + b;
    }

    addDaysToDate(date: Date, days: number): Date {
        return moment(date)
            .add(days, moment_duration.days)
            .toDate();
    }

    checkIfDateIsAfterToday(date: Date): boolean {
        return moment(date).isAfter(moment());
    }

    getDateFormat(date: Date, format: date_format) : string {
        return String(moment(date, format));
    }
    /**
     * Checks if date1 <= date2
    */
    checkIfDateIsSameOrBeforeDate(date1: Date, date2: Date): boolean {
        return moment(date1).isSameOrBefore(moment(date2));
    }

    getDateResettingTime(dateString: string | Date): Date {
        return moment(dateString)
            .hour(0)
            .minute(0)
            .second(0)
            .millisecond(0)
            .toDate();
    }

    subtractQuantity(date: Date, quantity: number, quantityType: moment_duration): Date {
        return moment(date)
            .subtract(quantity, quantityType)
            .toDate();
    }

    addQuantity(date: Date, quantity: number, quantityType: moment_duration): Date {
        return moment(date)
            .add(quantity, quantityType)
            .toDate();
    }

    /**
     * b - a
    */
    diff(a: Date, b: Date, measurement: moment_duration): number {
        return moment(b).diff(moment(a), measurement);
    }

    isInBetween(date1: Date, date2: Date, date3: Date): boolean {
        if (date1.valueOf() > date3.valueOf())
            return moment(date2).isBetween(moment(date3), moment(date1));
        return moment(date2).isBetween(moment(date1), moment(date3));
    }

    /**
     * Checks if date1 < date2
    */
    isBefore(date1: Date, date2: Date, measurement?: moment_duration): boolean {
        return moment(date1).isBefore(moment(date2), measurement)
    }

    /**
     * Checks if date1 > date2
    */
    isAfter(date1: Date, date2: Date, measurement?: moment_duration): boolean {
        return moment(date1).isAfter(moment(date2), measurement)
    }

    isSame(date1: Date, date2: Date, measurement?: moment_duration): boolean {
        return moment(date1).isSame(moment(date2), measurement)
    }

    dateFormat(date: Date, format: string): string {
        return moment(date).format(format);
    }

}
